import "../styles/FilterModal.css";
import React, { useState } from "react";

const FilterModal = ({ isOpen, setIsOpen, onApplyFilters, currentFilters = {} }) => {
  const [stockFilter, setStockFilter] = useState(currentFilters.stock_filter || "all");

  const handleApplyFilters = () => {
    const formData = new FormData(document.getElementById("filterForm"));
    const newFilters = {};

    // 数値・日付フィールドの共通処理
    const fields = [
      "buy_price", "sell_price", "set_price", "buy_specialprice",
      "update_date", "release_date"
    ];
    fields.forEach(field => {
      const value = formData.get(field);
      if (value) {
        newFilters[field] = value;
        newFilters[`${field}_operator`] = formData.get(`${field}_operator`);
      }
      newFilters[`${field}_include_null`] = formData.get(`${field}_include_null`) === "true";
    });

    // ジャンル1
    const genre1 = formData.get("genre1")?.trim();
    if (genre1) {
      newFilters.genre1 = genre1;
      newFilters.genre1_operator = formData.get("genre1_operator");
    }

    // カテゴリー
    const category_id = formData.get("category_id");
    if (category_id) {
      newFilters["category_id"] = category_id;
    }

    // スイッチ系
    const switches = [
      "buy_top_switch", "buy_specialprice_switch",
      "scale_stock_switch", "picture_switch", "csv_switch"
    ];
    switches.forEach(sw => {
      newFilters[sw] = formData.get(sw);
    });

    // 在庫フィルター
    if (stockFilter !== "all") {
      newFilters["stock_filter"] = stockFilter;
    }
    onApplyFilters(newFilters);
    setIsOpen(false);
  };
    // モーダルを閉じる
    const closeModal = (event) => {
    // クリックされたターゲットがモーダル本体（モーダル外）であることを確認
    if (event.target === event.currentTarget) {
        setIsOpen(false);  // モーダルを閉じる
    }
    };

  return (
    <div id="filterModal" className={`modal ${isOpen ? "open" : ""}`} onClick={closeModal}>
      <div className="modal-content">
        <span className="close" onClick={() => setIsOpen(false)}>&times;</span>
        <h3>絞り込み条件</h3>
        <form id="filterForm" className="filter-form-container">

          {/* === 価格フィルター === */}
          <div className="filter-row">
            <label>買取</label>
            <input type="number" name="buy_price" placeholder="買取価格" />
            <input type="radio" name="buy_price_operator" value="gte" defaultChecked />以上
            <input type="radio" name="buy_price_operator" value="lte" />以下
            <input type="checkbox" name="buy_price_include_null" value="true" defaultChecked />Null
          </div>

          <div className="filter-row">
            <label>販売</label>
            <input type="number" name="sell_price" placeholder="販売価格" />
            <input type="radio" name="sell_price_operator" value="gte" defaultChecked />以上
            <input type="radio" name="sell_price_operator" value="lte" />以下
            <input type="checkbox" name="sell_price_include_null" value="true" defaultChecked />Null
          </div>

          <div className="filter-row">
            <label>SET</label>
            <input type="number" name="set_price" placeholder="SET価格" />
            <input type="radio" name="set_price_operator" value="gte" defaultChecked />以上
            <input type="radio" name="set_price_operator" value="lte" />以下
            <input type="checkbox" name="set_price_include_null" value="true" defaultChecked />Null
          </div>

          <div className="filter-row">
            <label>特別</label>
            <input type="number" name="buy_specialprice" placeholder="特別買取価格" />
            <input type="radio" name="buy_specialprice_operator" value="gte" defaultChecked />以上
            <input type="radio" name="buy_specialprice_operator" value="lte" />以下
            <input type="checkbox" name="buy_specialprice_include_null" value="true" defaultChecked />Null
          </div>

          {/* === フリーワードフィルター === */}
          <div className="filter-row">
            <label>ジャンル1</label>

            <input
              type="text"
              name="genre1"
              placeholder="ジャンル1"
              defaultValue={currentFilters.genre1 || ""}
            />

            <select
              name="genre1_operator"
              defaultValue={currentFilters.genre1_operator || "contains"}
            >
              <option value="contains">含む</option>
              <option value="exclude">除外</option>
            </select>
          </div>

          {/* === 日付フィルター === */}
          <div className="filter-row">
            <label>更新日</label>
            <input type="date" name="update_date" />
            <input type="radio" name="update_date_operator" value="gte" defaultChecked />以降
            <input type="radio" name="update_date_operator" value="lte" />以前
            <input type="checkbox" name="update_date_include_null" value="true" defaultChecked />Null
          </div>

          <div className="filter-row">
            <label>発売日</label>
            <input type="date" name="release_date" />
            <input type="radio" name="release_date_operator" value="gte" defaultChecked />以降
            <input type="radio" name="release_date_operator" value="lte" />以前
            <input type="checkbox" name="release_date_include_null" value="true" defaultChecked />Null
          </div>

          {/* === スイッチ系 === */}
          <div className="filter-row">
            <label>TOP:</label>
            <select name="buy_top_switch">
              <option value="all">全て</option>
              <option value="true">ON</option>
              <option value="false">OFF</option>
            </select>

            <label>特別:</label>
            <select name="buy_specialprice_switch">
              <option value="all">全て</option>
              <option value="true">ON</option>
              <option value="false">OFF</option>
            </select>

            <label>ストック:</label>
            <select name="scale_stock_switch">
              <option value="all">全て</option>
              <option value="true">ON</option>
              <option value="false">OFF</option>
            </select>
            
            <label>分類:</label>
            <select name="category_id">
              <option value="">全て</option>
              <option value="1">1FPrize</option>
              <option value="2">1FTOY</option>
              <option value="3">2FPrize</option>
              <option value="4">2FTOY</option>
              <option value="5">1FGOODS</option>
              <option value="6">2FGOODS</option>
            </select>

            <label>画像:</label>
            <select name="picture_switch">
              <option value="all">全て</option>
              <option value="true">ON</option>
              <option value="false">OFF</option>
            </select>

            <label>CSV:</label>
            <select name="csv_switch">
              <option value="all">全て</option>
              <option value="true">ON</option>
              <option value="false">OFF</option>
            </select>
          </div>

          {/* === 在庫数 === */}
          <div className="filter-row">
            <label>在庫数:</label>
            <label>
              <input
                type="radio"
                name="stock_filter"
                value="all"
                checked={stockFilter === "all"}
                onChange={() => setStockFilter("all")}
              /> 全て
            </label>
            <label>
              <input
                type="radio"
                name="stock_filter"
                value="zero"
                checked={stockFilter === "zero"}
                onChange={() => setStockFilter("zero")}
              /> 在庫0のみ
            </label>
            <label>
              <input
                type="radio"
                name="stock_filter"
                value="exclude_zero"
                checked={stockFilter === "exclude_zero"}
                onChange={() => setStockFilter("exclude_zero")}
              /> 在庫0を除外
            </label>
          </div>

          <button type="button" onClick={handleApplyFilters} className="apply-btn">
            絞り込み
          </button>
        </form>
      </div>
    </div>
  );
};

export default FilterModal;
